import { useRef } from 'react'

import { Popover, PopoverAnchor, PopoverContent } from '@/components/ui'
import type { TourStep } from './steps'
import { type TourStepActions, TourStepContent } from './TourStepContent'
import { useIsNarrowScreen } from './useIsNarrowScreen'

const CARD_GAP = 12

interface TourStepCardProps extends TourStepActions {
  step: TourStep
  number: number
  total: number
  hole: DOMRect
}

// Beside the area on wide screens, docked at the bottom on narrow ones.
export const TourStepCard = ({ hole, ...contentProps }: TourStepCardProps) => {
  const isNarrow = useIsNarrowScreen()
  const anchor = useRef({ getBoundingClientRect: () => hole })
  anchor.current.getBoundingClientRect = () => hole

  if (isNarrow) {
    return (
      <div
        role="dialog"
        aria-label={contentProps.step.title}
        className="fixed inset-x-0 bottom-0 z-50 border-t bg-popover p-4 text-popover-foreground shadow-lg"
      >
        <TourStepContent {...contentProps} />
      </div>
    )
  }

  return (
    <Popover open>
      <PopoverAnchor virtualRef={anchor} />
      <PopoverContent
        aria-label={contentProps.step.title}
        side="bottom"
        sideOffset={CARD_GAP}
        updatePositionStrategy="always"
        className="w-96 motion-reduce:animate-none"
        onInteractOutside={(event) => event.preventDefault()}
        onEscapeKeyDown={(event) => event.preventDefault()}
      >
        <TourStepContent {...contentProps} />
      </PopoverContent>
    </Popover>
  )
}
